import { Theme, css } from '@emotion/react';

export const card = ({ typography, breakpoints }: Theme) => css`
  width: ${typography.pxToRem(268)};
  scroll-snap-align: start;
  ${breakpoints.up('sm')} {
    width: auto;
    scroll-snap-align: none;
  }
`;

export const emptyCard = ({ typography, breakpoints }: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: ${typography.pxToRem(144)};
  ${breakpoints.up('sm')} {
    display: none;
  }
`;

export const gridItemExperience = css`
  display: flex;
`;

export const gridContent = css`
  padding-left: 0;
  padding-right: 0;
`;
